module.exports = __webpack_public_path__ + "img/yepanoff.1069415b.png";